module.exports = __webpack_public_path__ + "static/media/ic_double_left_arrow.bd65d3ae.svg";